import React, { Fragment, useState } from "react";
import {
    Dialog,
    AppBar,
    IconButton,
    Toolbar,
    Typography,
    Slide,
    Tabs,
    Tab,
    Box,
    MuiThemeProvider
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { useStyles } from "./styles";
import temaFormulario from "../../../../Styles/Temas/temaFormulario";
import ListaResultados from "./ListaResultados";

export default function DrawerVisualizarResultado({ open, fechar, resultadoSelecionado = {}, cpf }) {

    const classes = useStyles();
    const [currentTab, setCurrentTab] = useState(0);

    const onChangeTab = (event, newValue) => {
        setCurrentTab(newValue);
    }

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={fechar}
            TransitionComponent={Transition}
        >
            <MuiThemeProvider theme={temaFormulario}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            id="btn-close"
                            edge="start"
                            color="inherit"
                            onClick={fechar}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Resultado - {resultadoSelecionado.competencia ?? 'xx/xxxx'}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </MuiThemeProvider>
            <Fragment>
                <div>
                    <MuiThemeProvider theme={temaFormulario}>
                            <div className={classes.rootTabs}>
                        <AppBar position="static">
                                <Tabs value={currentTab} onChange={onChangeTab} aria-label="tabs-resultados">
                                    <Tab label="CONSIDERADOS" />
                                    <Tab label="NÃO CONSIDERADOS" />
                                </Tabs>
                        </AppBar>
                            </div>
                    </MuiThemeProvider>
                    <TabPanel value={currentTab} index={0}>
                        <ListaResultados considerado={true} competencia={resultadoSelecionado.competencia} cpf={cpf} />
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <ListaResultados considerado={false} competencia={resultadoSelecionado.competencia} cpf={cpf} />
                    </TabPanel>
                </div>
            </Fragment>
        </Dialog>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
});

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tab-resultados-${index}`}
            aria-labelledby={`tab-resultados-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography style={{ fontWeight: 700 }} component={'span'}>{children}</Typography>
                </Box>
            )}
        </div>
    )
}
